import axios from 'axios';

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const TOKEN_KEY = 'dealrun_token';

export const api = axios.create({ baseURL: `${BACKEND_URL}/api` });

const VISITOR_KEY = 'dealgo_vid';
export const visitorId = () => {
  let v = localStorage.getItem(VISITOR_KEY);
  if (!v) { v = (window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`); localStorage.setItem(VISITOR_KEY, v); }
  return v;
};

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  config.headers['X-Visitor-Id'] = visitorId();
  return config;
});

// Stale-while-revalidate GET: returns what we already have (memory → sessionStorage) and a promise for fresh data.
const mem = new Map();
const SWR_PREFIX = 'dealgo_swr:';
const readCache = (url) => {
  if (mem.has(url)) return mem.get(url);
  try { const hit = JSON.parse(sessionStorage.getItem(SWR_PREFIX + url)); if (hit) mem.set(url, hit); return hit; } catch { return null; }
};
const writeCache = (url, data) => {
  const entry = { at: Date.now(), data };
  mem.set(url, entry);
  try { sessionStorage.setItem(SWR_PREFIX + url, JSON.stringify(entry)); } catch { /* quota */ }
  return data;
};
const inflight = new Map();
export const swrGet = (url, { maxAge = 30000 } = {}) => {
  const hit = readCache(url);
  const fresh = hit && Date.now() - hit.at < maxAge;
  let promise = fresh ? Promise.resolve(hit.data) : inflight.get(url);
  if (!promise) {
    promise = api.get(url).then((r) => writeCache(url, r.data)).finally(() => inflight.delete(url));
    inflight.set(url, promise);
  }
  return { cached: hit?.data ?? null, promise };
};
export const swrInvalidate = (url) => { mem.delete(url); try { sessionStorage.removeItem(SWR_PREFIX + url); } catch { /* ignore */ } };
export const sameData = (a, b) => JSON.stringify(a) === JSON.stringify(b);

export const prefetchCatalog = (deal) => {
  if (!deal?.id) return;
  swrGet(`/catalogs/${deal.id}`, { maxAge: 120000 }).promise.catch(() => {});
  if (deal.brand_id) swrGet(`/brands/${deal.brand_id}`, { maxAge: 120000 }).promise.catch(() => {});
  import('../pages/CatalogPage').catch(() => {});
  deal.images?.slice(0, 2).forEach((src) => { const img = new Image(); img.src = resolveUrl(src); });
};

export const resolveUrl = (url) => (url && url.startsWith('/') ? `${BACKEND_URL}${url}` : url);
export const thumbUrl = (url) => (url && url.startsWith('/api/files/') ? `${BACKEND_URL}${url}?size=thumb` : resolveUrl(url));

export const formatDate = (iso) => {
  if (!iso) return '';
  const [y, m, d] = iso.split('-');
  return `${d}/${m}/${y}`;
};

export const formatLongDate = (iso) => {
  if (!iso) return '';
  return new Date(`${iso}T00:00:00`).toLocaleDateString('fr-FR', { day: '2-digit', month: 'long', year: 'numeric' });
};

export const formatApiError = (err) => {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || 'Une erreur s’est produite';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(' ');
  return detail?.message || detail?.msg || String(detail);
};

export const SECTIONS = [
  { id: 'top', label: 'TOP 6' },
  { id: 'weekly', label: 'Offres de la semaine' },
  { id: 'flyers', label: 'Catalogues en cours' },
  { id: 'recommended', label: 'Nous vous recommandons aussi' },
];

export const BADGES = ['Nouveau', 'Dernière chance', 'Promo', 'Exclusif'];
